import React from "react";
import { Toolbar, AppBar, Box, Typography, CssBaseline } from '@mui/material';
import PageAppBar2 from "./appbar/PageAppBar2";
import PageAppBar3 from "./appbar/PageAppBar3";
import LocationButton from "./pagecontent/LocationButton";

function PageAppBar() {
    return (
        <>
        <CssBaseline />
        
        {/*APP BAR DESKTOP*/}
       
        <AppBar sx={{ position: 'static' }} style={{ backgroundColor: "#424242" }}>
            <Toolbar style={{ backgroundColor: "#424242" }} sx={{ margin: '1rem' }}>

                <Box component="img" sx={{height: 70, borderRadius:'8px'}} alt="Your logo." src="images/LogoAppBar.jpg" />

                <Box sx={{ marginLeft: 'auto', display: "inline-flex" }}>

                    <Box style={{ backgroundColor: 'transparent', width: '300px' }}>

                        <LocationButton />

                        <Typography style={{ color: "white", fontSize: "13px" }} component="div">
                            ENDEREÇO
                        </Typography>
                        <Typography mt={1} ml={3} style={{ color: "#9e9e9e", fontStyle: "bold" }} variant="subtitle2" color="text.secondary">
                            R. Santos Dumond, Nº64 - Centro
                        </Typography>
                    </Box>

                    <PageAppBar2 />
                    <PageAppBar3 />

                </Box>
            </Toolbar>
        </AppBar>  
        </>     
    );
};
export default PageAppBar;